export default __webpack_public_path__ + "images/8652f1f50907fb5dcf4e6f992012e7fb.png";